import { MutationTree } from "vuex";
import { IPaymentState } from "@/core/interfaces/state/paymentState.interface";
import {
  IPayment,
  IPayments,
  IPaymentMethodsByAeroglobeSector,
  ISystemBank,
} from "@/core/interfaces/state/payments.interface";

const mutations: MutationTree<IPaymentState> = {
  enableIsFetchingPayments(state) {
    state.isFetchingPayments = true;
  },
  disbaleIsFetchingPayments(state) {
    state.isFetchingPayments = false;
  },
  enableIsFetchingPayment(state) {
    state.isFetchingPayment = true;
    state.payment = null;
  },
  enableIsCreatingPayment(state) {
    state.isCreatingPayment = true;
  },
  disableIsCreatingPayment(state) {
    state.isCreatingPayment = false;
  },
  savePayments(state, payload: IPayments) {
    state.payments = payload;
    state.isFetchingPayments = false;
  },
  savePayment(state, payload: IPayment) {
    state.payment = payload;
    state.isFetchingPayment = false;
  },
  setPaymentsByMethods(state, payload: IPaymentMethodsByAeroglobeSector) {
    state.paymentsByMethods = payload;
  },
  enableIsUpdatingBankTransfer(state) {
    state.isUpdatingBankTransfer = true;
  },
  disableIsUpdatingBankTransfer(state) {
    state.isUpdatingBankTransfer = false;
  },
  enableIsFetchingSystemBanks(state) {
    state.isFetchingSystemBanks = true;
  },
  disableIsFetchingSystemBanks(state) {
    state.isFetchingSystemBanks = false;
  },
  saveSystemBanks(state, payload: ISystemBank[]) {
    state.systemBanks = payload;
    state.isFetchingSystemBanks = false;
  },
};

export default mutations;
